import type { MenuEntry } from '../../ui/menu';
import type { FileVersion } from '../../services/versions';
import { versionLines } from './versionLabels';

/** How many versions the submenu shows before "Show all versions". */
export const MENU_VERSIONS = 6;

/**
 * Document ▸ Version history ▸ (W5-AR1, Farah's pick B): the recent versions with their
 * pictures, then Name current version… and Show all versions. A version pressed opens the
 * panel on it, where it is previewed and restored; nothing is restored from a menu row.
 */
export function versionHistoryMenu(o: {
  versions: readonly FileVersion[] | null;
  now?: Date;
  open(version: FileVersion | null): void;
  nameCurrent(): void;
}): MenuEntry {
  const rows: MenuEntry[] = (o.versions ?? []).slice(0, MENU_VERSIONS).map((version) => {
    const { title, detail } = versionLines(version, o.now);
    return { id: `version-${version.id}`, label: title, note: detail, thumb: version.thumbnailUrl, onSelect: () => o.open(version) };
  });
  return {
    kind: 'submenu',
    id: 'versions',
    label: 'Version history',
    items: [
      ...rows,
      ...(rows.length ? [{ kind: 'separator' as const }] : []),
      { id: 'version-name', label: 'Name current version…', onSelect: o.nameCurrent },
      { id: 'version-all', label: 'Show all versions', onSelect: () => o.open(null) },
    ],
  };
}
